<template>
    <div>
        <c-panel title="FILTROS" titleIcon="fas fa-filter">
            <el-form label-position="top" @submit.native.prevent>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="8" :md="6">
                        <el-form-item label="Período diagnóstico">
                            <el-select v-model="filtro.periodo_diagnostico_id" placeholder="Selecione" @change="load" clearable filterable style="width: 100%;">
                                <el-option v-for="p in periodos" :key="p.id" :label="p.descricao" :value="p.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8" :md="8">
                        <el-form-item label="Escolas (vazio = todas)">
                            <el-select v-model="filtro.instituicao_ids" multiple collapse-tags filterable @change="load" style="width: 100%;">
                                <el-option v-for="e in instituicoes" :key="e.id" :label="e.nome" :value="e.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8" :md="4">
                        <el-form-item label="Turno">
                            <el-select v-model="filtro.turnos" multiple collapse-tags @change="load" style="width: 100%;">
                                <el-option label="MATUTINO" :value="1"></el-option>
                                <el-option label="VESPERTINO" :value="2"></el-option>
                                <el-option label="NOTURNO" :value="3"></el-option>
                                <el-option label="INTEGRAL" :value="4"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="6" style="padding-top: 24px;">
                        <el-button @click="exportarPdf" type="primary" plain :disabled="!filtro.periodo_diagnostico_id">
                            <i class="el-icon-printer"></i> EXPORTAR PDF
                        </el-button>
                        <el-button @click="imprimirGraficos" type="primary" plain :disabled="!dados" style="margin-left: 6px;">
                            <i class="el-icon-picture-outline"></i> IMPRIMIR GRÁFICOS
                        </el-button>
                    </el-col>
                </el-row>
            </el-form>
        </c-panel>

        <div v-if="!filtro.periodo_diagnostico_id" class="u-text-center u-mt-25" style="color: #909399;">
            Selecione um período diagnóstico para visualizar o consolidado da rede.
        </div>

        <div v-else>
            <div v-if="loading" class="u-text-center u-mt-25">
                <img src="/public/img/loading-bar.gif" />
            </div>

            <div v-else-if="dados">
                <c-panel title="TOTAL DA REDE" titleIcon="fas fa-globe">
                    <div class="kpis">
                        <div class="card kpi" v-for="n in niveisDisponiveis" :key="n.v">
                            <div class="kpi__label">
                                <span :style="`display:inline-block;width:10px;height:10px;background:${n.cor};margin-right:6px;`"></span>{{ n.l }}
                            </div>
                            <div class="kpi__value">{{ dados.total_geral[n.v] || 0 }}</div>
                            <div class="kpi__hint">{{ pct(dados.total_geral[n.v] || 0) }}%</div>
                        </div>
                    </div>
                    <div class="u-text-right" style="font-size:12px;color:#909399;margin-top:6px;">
                        Total de lançamentos: <b>{{ dados.total_lancamentos }}</b>
                    </div>
                </c-panel>

                <el-row :gutter="14">
                    <el-col :xs="24" :md="12">
                        <c-panel title="DISTRIBUIÇÃO POR ESCOLA" titleIcon="fas fa-chart-bar">
                            <div class="chart-box chart-box--md">
                                <bar-chart class="chart-canvas" :chart-data="chartPorEscola"></bar-chart>
                            </div>
                        </c-panel>
                    </el-col>
                    <el-col :xs="24" :md="12">
                        <c-panel title="DISTRIBUIÇÃO POR ANO/SEGMENTO" titleIcon="fas fa-chart-bar">
                            <div class="chart-box chart-box--md">
                                <bar-chart class="chart-canvas" :chart-data="chartPorCurso"></bar-chart>
                            </div>
                        </c-panel>
                    </el-col>
                </el-row>

                <c-panel title="EVOLUÇÃO ENTRE PERÍODOS" titleIcon="fas fa-chart-line" v-if="dados.evolucao && dados.evolucao.length">
                    <div class="chart-box chart-box--md">
                        <bar-chart class="chart-canvas" :chart-data="chartEvolucao"></bar-chart>
                    </div>
                </c-panel>

                <c-panel title="DETALHAMENTO POR ESCOLA" titleIcon="fas fa-table">
                    <div class="container-table">
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th>Escola</th>
                                    <th style="width: 80px;">Total</th>
                                    <th v-for="n in niveisDisponiveis" :key="n.v" style="width: 90px;">{{ n.curto || n.l }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="e in dados.por_escola" :key="e.id">
                                    <td>{{ e.nome }}</td>
                                    <td>{{ e.total }}</td>
                                    <td v-for="n in niveisDisponiveis" :key="n.v">{{ e.niveis[n.v] || 0 }}</td>
                                </tr>
                                <tr v-if="!dados.por_escola.length">
                                    <td :colspan="2 + niveisDisponiveis.length" class="u-text-center" style="padding: 16px; color: #909399;">
                                        Sem dados para os filtros selecionados.
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </c-panel>
            </div>
        </div>
    </div>
</template>

<script>
import { tabulacaoNiveisPorTipo } from '@/shared/constants'

export default {
    components: {
        cPanel: () => import('@/shared/c-panel/c-panel.vue'),
        BarChart: () => import('@/chart/BarChart')
    },
    props: {
        tipo: { type: String, required: true }
    },
    data: () => ({
        loading: false,
        periodos: [],
        instituicoes: [],
        filtro: {
            periodo_diagnostico_id: '',
            instituicao_ids: [],
            curso_ids: [],
            turnos: []
        },
        dados: null,
        chartPorEscola: { labels: [], datasets: [] },
        chartPorCurso: { labels: [], datasets: [] },
        chartEvolucao: { labels: [], datasets: [] }
    }),
    computed: {
        niveisDisponiveis () { return tabulacaoNiveisPorTipo(this.tipo) }
    },
    mounted () {
        this.carregarPeriodos()
        this.carregarInstituicoes()
    },
    methods: {
        pct (n) {
            const t = this.dados && this.dados.total_lancamentos ? this.dados.total_lancamentos : 0
            if (!t) return '0,0'
            return (100 * n / t).toFixed(1).replace('.', ',')
        },
        carregarPeriodos () {
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/periodo-diagnostico/getAll`, this.$store.getters.getHeaderAuth)
                .then(r => { this.periodos = r.data || [] })
        },
        carregarInstituicoes () {
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/instituicao/getAll`, this.$store.getters.getHeaderAuth)
                .then(r => { this.instituicoes = r.data || [] })
                .catch(() => { this.instituicoes = [] })
        },
        load () {
            if (!this.filtro.periodo_diagnostico_id) return
            this.loading = true
            this.dados = null
            const payload = { ...this.filtro }
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/tabulacao/consolidadoRede/${this.tipo}`, payload, this.$store.getters.getHeaderAuth)
                .then(r => {
                    this.loading = false
                    if (r.data && r.data.erro) {
                        window.eventBus.$emit('alert', { msg: typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text, type: 'warning' })
                        return
                    }
                    this.dados = r.data
                    this.atualizarGraficos()
                })
                .catch(error => { this.loading = false; this.$store.commit('throwException', error) })
        },
        atualizarGraficos () {
            // Por escola: cada escola = label do eixo X, séries = níveis
            const escolas = this.dados.por_escola || []
            this.chartPorEscola = {
                labels: escolas.map(e => this.truncar(e.nome, 18)),
                datasets: this.niveisDisponiveis.map(n => ({
                    label: n.curto || n.l,
                    backgroundColor: n.cor,
                    data: escolas.map(e => e.niveis[n.v] || 0)
                }))
            }
            // Por curso
            const cursos = this.dados.por_curso || []
            this.chartPorCurso = {
                labels: cursos.map(c => this.truncar(c.nome, 14)),
                datasets: this.niveisDisponiveis.map(n => ({
                    label: n.curto || n.l,
                    backgroundColor: n.cor,
                    data: cursos.map(c => c.niveis[n.v] || 0)
                }))
            }
            // Evolução: cada período = label, séries = níveis
            const evolucao = this.dados.evolucao || []
            this.chartEvolucao = {
                labels: evolucao.map(ev => ev.periodo_descricao),
                datasets: this.niveisDisponiveis.map(n => ({
                    label: n.curto || n.l,
                    backgroundColor: n.cor,
                    data: evolucao.map(ev => ev.niveis[n.v] || 0)
                }))
            }
        },
        truncar (s, max) {
            if (!s) return ''
            return s.length > max ? (s.substring(0, max - 1) + '…') : s
        },
        exportarPdf () {
            if (!this.filtro.periodo_diagnostico_id) return
            window.eventBus.$emit('loading', true)
            const payload = { ...this.filtro }
            this.$axios.post(
                `${this.$store.state.config.baseUrlApi}/api/tabulacao/imprimirRede/${this.tipo}`,
                payload,
                { ...this.$store.getters.getHeaderAuthExcel }
            ).then(response => {
                window.eventBus.$emit('loading', false)
                const blob = new Blob([response.data], { type: response.headers['content-type'] || 'application/pdf' })
                const link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.target = '_blank'
                link.click()
                window.URL.revokeObjectURL(link.href)
            }).catch(error => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
        },
        imprimirGraficos () {
            if (!this.dados) return

            // Os gráficos são chart.js (canvas). Captura cada canvas como PNG na ordem em que aparecem.
            const titulos = ['DISTRIBUIÇÃO POR ESCOLA', 'DISTRIBUIÇÃO POR ANO/SEGMENTO']
            if (this.dados.evolucao && this.dados.evolucao.length) titulos.push('EVOLUÇÃO ENTRE PERÍODOS')

            const canvases = Array.from(this.$el.querySelectorAll('.chart-canvas canvas'))
            if (!canvases.length) {
                window.eventBus.$emit('alert', { msg: 'Os gráficos ainda não foram renderizados. Aguarde um instante e tente novamente.', type: 'warning' })
                return
            }

            const imagens = canvases.map((c, i) => ({ titulo: titulos[i] || '', imagem: c.toDataURL('image/png') }))
            const periodo = (this.periodos.find(p => p.id === this.filtro.periodo_diagnostico_id) || {}).descricao || ''

            window.eventBus.$emit('loading', true)
            this.$axios.post(
                `${this.$store.state.config.baseUrlApi}/api/tabulacao/imprimirGraficosRede/${this.tipo}`,
                { periodo_descricao: periodo, total_lancamentos: this.dados.total_lancamentos, imagens: imagens },
                { ...this.$store.getters.getHeaderAuthExcel }
            ).then(response => {
                window.eventBus.$emit('loading', false)
                const blob = new Blob([response.data], { type: response.headers['content-type'] || 'application/pdf' })
                const link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.target = '_blank'
                link.click()
                window.URL.revokeObjectURL(link.href)
            }).catch(error => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
        }
    }
}
</script>

<style scoped>
.kpis { display: flex; flex-wrap: wrap; gap: 10px; }
.card.kpi { flex: 1 0 110px; padding: 8px 10px; border: 1px solid #ebeef5; border-radius: 4px; background: #fff; }
.kpi__label { font-size: 11px; color: #606266; }
.kpi__value { font-size: 18px; font-weight: bold; color: #303133; }
.kpi__hint { font-size: 11px; color: #909399; }
.chart-box { height: 280px; position: relative; }
.chart-box--md { height: 320px; }
.chart-canvas { height: 100%; width: 100%; }
</style>
